/// <reference path="../../../../core/extensions/string/string.extension.d.ts" />
import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import '../../../../core/extensions/string/string.extension';
import { BaseFormComponent } from '../../../../core/base-classes/base-form-component';
import { InputLabel } from '../../../../parts/input-label/input-label.component';
import { RichTextEditorComponent } from '../../../../parts/rich-text-editor/rich-text-editor.component';
import { CommunicationsMessagingConstants } from '../../../../core/constants/messaging.constants';
import { UserSessionService } from '../../../../core/services/user-session.service';

export interface ComposeStepValue {
  subject: string;
  body: string;
  footer: string;
}

@Component({
  selector: 'ms-compose-step',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, InputLabel, RichTextEditorComponent],
  templateUrl: './compose-step.component.html'
})
export class ComposeStepComponent extends BaseFormComponent {

  private formBuilder = inject(FormBuilder);
  private userSessionService = inject(UserSessionService);

  // Resolve the {organizationName} token to the active organization's name up front — the page only renders
  // with an active organization, so it is always available here.
  private readonly defaultFooter = CommunicationsMessagingConstants.DEFAULT_FOOTER()
    .replaceValuesWithObject({ organizationName: this.userSessionService.activeOrganization()?.name ?? '' });

  public composeForm: FormGroup = this.formBuilder.group({
    subject: ['', [Validators.required, Validators.maxLength(150)]],
    body: ['', [Validators.required]],
    footer: [this.defaultFooter, [Validators.required]]
  });

  public get isValid(): boolean {
    return this.composeForm.valid;
  }

  public markAllTouched(): void {
    this.composeForm.markAllAsTouched();
  }

  public reset(): void {
    this.composeForm.reset({
      subject: '',
      body: '',
      footer: this.defaultFooter
    });
  }

  public getValue(): ComposeStepValue {
    return this.composeForm.getRawValue() as ComposeStepValue;
  }
}
